import API from "@utils/plugins/API";

const VesselTypeFFFAOService = {
  all: (params) => {
    return API.get("vessel-types-fffao", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("vessel-types-fffao", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`vessel-types-fffao/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`vessel-types-fffao/${id}`);
  },
  destroy: (id) => {
    return API.delete(`vessel-types-fffao/${id}`);
  },
};

export default VesselTypeFFFAOService;
